import { promptInApp } from "../common/AppDialog";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ClipboardCopy } from "lucide-react";

export default function ArticlePermalinkButton() {
  const location = useLocation();
  const [copied, setCopied] = useState(false);
  const isArticle = location.pathname.startsWith("/notas/") || location.pathname.startsWith("/a/");
  const editorOwnsLink = Boolean(location.state?.editorOpen);

  useEffect(() => {
    setCopied(false);
  }, [location.pathname]);

  const copy = useCallback(async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch (_e) {
      await promptInApp({
        title: "Copiar link",
        message: "El navegador no permitió copiar automáticamente. Copiá el enlace desde acá.",
        defaultValue: url,
        confirmLabel: "Listo",
      });
    }
  }, []);

  if (!isArticle || editorOwnsLink) return null;

  return (
    <button
      type="button"
      onClick={copy}
      aria-label="Copiar link de este artículo"
      title="Copiar link de este artículo"
      style={styles.button}
    >
      <ClipboardCopy size={18} />
      <span>{copied ? "Copiado ✓" : "Copiar link"}</span>
    </button>
  );
}

const styles = {
  button: {
    position: "fixed",
    zIndex: 1250,
    top: "max(12px, env(safe-area-inset-top))",
    right: "max(12px, env(safe-area-inset-right))",
    minHeight: 44,
    padding: "0 13px",
    borderRadius: 11,
    border: "1px solid rgba(212,175,55,0.32)",
    background: "rgba(18,18,18,0.9)",
    backdropFilter: "blur(16px)",
    color: "#D4AF37",
    boxShadow: "0 8px 24px rgba(0,0,0,0.32)",
    display: "flex",
    alignItems: "center",
    gap: 7,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 750,
  },
};
